export default __webpack_public_path__ + "static/foreground3_light-be1d89a7163f3b97dc57d0995e78de97.png";